/* tslint:disable */
/* eslint-disable */
/**
 * Bericht Einreichen
 * RVC und DBBG Berichte in das Berichtsmanagement einreichen.
 *
 * The version of the OpenAPI document: 1.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DbbgEinsatzOperationenPruefungsergebnis
 */
export interface DbbgEinsatzOperationenPruefungsergebnis {
    /**
     * 
     * @type {number}
     * @memberof DbbgEinsatzOperationenPruefungsergebnis
     */
    id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DbbgEinsatzOperationenPruefungsergebnis
     */
    warnungen: Array<string>;
}

/**
 * Check if a given object implements the DbbgEinsatzOperationenPruefungsergebnis interface.
 */
export function instanceOfDbbgEinsatzOperationenPruefungsergebnis(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "warnungen" in value;

    return isInstance;
}

export function DbbgEinsatzOperationenPruefungsergebnisFromJSON(json: any): DbbgEinsatzOperationenPruefungsergebnis {
    return DbbgEinsatzOperationenPruefungsergebnisFromJSONTyped(json, false);
}

export function DbbgEinsatzOperationenPruefungsergebnisFromJSONTyped(json: any, ignoreDiscriminator: boolean): DbbgEinsatzOperationenPruefungsergebnis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'warnungen': json['Warnungen'],
    };
}

export function DbbgEinsatzOperationenPruefungsergebnisToJSON(value?: DbbgEinsatzOperationenPruefungsergebnis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Warnungen': value.warnungen,
    };
}

